import React from 'react'
import styles from './styles.module.css'
import CodeLogin from '@page-components/Auth/CodeLogin'
import {sendPosthogData, EVENTS} from '@helpers/posthog'

export default function Login(props) {
  const {showRedBorder = false, onExistingEmailAccountDetected} = props

  return (
    <div className={styles.container}>
      <CodeLogin
        onLogin={() => {
          sendPosthogData(EVENTS.clicked.checkoutLogin)
        }}
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ onLogin: () => void; onExistingEmailAccoun... Remove this comment to see the full error message
        onExistingEmailAccountDetected={onExistingEmailAccountDetected}
        showRedBorder={showRedBorder}
      />
    </div>
  )
}
